import { ICanvasContent } from "./CanvasContent";
import { IFormatParameter } from "./FormatParameter";

export interface ICanvasContentParameter {
    id?: string;
    tag?: string;
    value?: string;
    canvasContentId?: string;
    formatParameterId?: string;
    formatParameter?: IFormatParameter;
    file?: File;
    campaignId?: number;
}

export class CanvasContentParameter implements ICanvasContentParameter {
    id?: string;
    tag?: string;
    value?: string;
    canvasContentId?: string;
    formatParameterId?: string;
    formatParameter?: IFormatParameter;
    file?: File;
    campaignId?: number;

    constructor();
    constructor(obj: ICanvasContentParameter);
    constructor(obj?: ICanvasContentParameter) {
        this.id = obj?.id || undefined;
        this.tag = obj?.tag || undefined;
        this.value = obj?.value || undefined;
        this.canvasContentId = obj?.canvasContentId || undefined;
        this.formatParameterId = obj?.formatParameterId || undefined;
        this.formatParameter = obj?.formatParameter || undefined;
        this.file = obj?.file || undefined;
        this.campaignId = obj?.campaignId || undefined;
    }
}
